const I18NextHttpBackend = require('i18next-http-backend');

module.exports = {
  i18n: {
    defaultLocale: 'default',
    locales: ['default', 'en-HK', 'zh-HK', 'en-SG'],
    localeDetection: false,
    backend: {
      loadPath: process.env.I18N_PATH,
      addPath: process.env.I18N_PATH,
    },
  },
  debug: false,
  ns: ['common'],
  serializeConfig: false,
  use: process.env.LOAD_I18N_FROM_BE === 'true' ? [I18NextHttpBackend] : [],
};
